import base from "./base"; // 导入接口域名列表
import axios from "../http"; // 导入http中创建的axios实例
import qs from "qs"; // 根据需求是否导入qs模块
const getUser = {
  getAllConfig(params) {
    return axios.post(
      `${base.bd}/mobile/power/plugin_open_all`,
      qs.stringify(params)
    );
  },
  getConfigcate(params) {
    return axios.post(`${base.bd}/mobile/config/lists`, qs.stringify(params));
  },
  getAppDownInfo(params) {
    return axios.post(`${base.bd}/mobile/app/down`, qs.stringify(params));
  },
  getConfigInfo(params) {
    return axios.post(
      `${base.bd}/mobile/power/find_by_cate`,
      qs.stringify(params)
    );
  },
  pwd_login(params) {
    return axios.post(
      `${base.bd}/mobile/power/user_login`,
      qs.stringify(params)
    );
  },
  pwd_register(params) {
    return axios.post(`${base.bd}/mobile/power/user_reg`, qs.stringify(params));
  },
  pwd_reset(params) {
    return axios.post(
      `${base.bd}/mobile/power/change_password`,
      qs.stringify(params)
    );
  },
  loginOut(params) {
    return axios.post(`${base.bd}/mobile/user/logout`, qs.stringify(params));
  },

  is_have_user(params) {
    return axios.post(
      `${base.bd}/mobile/power/is_have_user`,
      qs.stringify(params)
    );
  },
  send_code(params) {
    return axios.post(`${base.bd}/mobile/power/sendcode`, qs.stringify(params));
  },
  getUserInfo(params) {
    return axios.post(
      `${base.bd}/mobile/ucenter/user_all`,
      qs.stringify(params)
    );
  },
  imBuddyLists(params) {
    return axios.post(`${base.bd}/mobile/im_buddy/lists`, qs.stringify(params));
  },

  getHongBaoAllStatus(params) {
    return axios.post(
      `${base.bd}/mobile/transfer/lists_now`,
      qs.stringify(params)
    );
  },
  getGroupList(params) {
    return axios.post(
      `${base.bd}/mobile/im_team/my_lists`,
      qs.stringify(params)
    );
  },
  get_agreement(params) {
    return axios.post(`${base.bd}/mobile/power/contact`, qs.stringify(params));
  },
  exit_team(params) {
    return axios.post(
      `${base.bd}/mobile/im_team/drop_out_im`,
      qs.stringify(params)
    );
  },

  //创建群聊
  create_team(params) {
    return axios.post(
      `${base.bd}/mobile/im_team/im_team_work`,
      qs.stringify(params)
    );
  },

  editTeam(params) {
    return axios.post(`${base.bd}/mobile/im_team/edit`, qs.stringify(params));
  },

  pick_friend_inteam(params) {
    return axios.post(
      `${base.bd}/mobile/im_team/pick_up_friends`,
      qs.stringify(params)
    );
  },
  imBuddySearch(params) {
    return axios.post(
      `${base.bd}/mobile/im_buddy/search`,
      qs.stringify(params)
    );
  },
  //获取用户信息
  get_frinedinfo(params) {
    return axios.post(
      `${base.bd}/mobile/im_buddy/friend_data`,
      qs.stringify(params)
    );
  },

  imBuddyApplications(params) {
    return axios.post(
      `${base.bd}/mobile/im_buddy/applications`,
      qs.stringify(params)
    );
  },

  //删除好友
  del_myfriend(params) {
    return axios.post(
      `${base.bd}/mobile/im_buddy/del_buddy`,
      qs.stringify(params)
    );
  },

  //解散本群
  dismiss_team(params) {
    return axios.post(`${base.bd}/mobile/im_team/del`, qs.stringify(params));
  },

  //定制表情
  get_memelist(params) {
    return axios.post(`${base.bd}/mobile/meme/meme_list`, qs.stringify(params));
  },
  login(params) {
    return axios.post(`${base.bd}/mobile/power/user_login`, qs.stringify(params));
  },
  postSaveUserInfo(params) {
    return axios.post(`${base.bd}/mobile/ucenter/complete_info`, qs.stringify(params));
  },

  //验证手机号
  powerValidateUsername(params) {
    return axios.post(`/api/mobile/power/validate_username`, qs.stringify(params));
  },
  usernameChangePassword(params) {
    return axios.post("/api/mobile/power/change_password", qs.stringify(params));
  },
  usernameLogin(params) {
    return axios.post("/api/mobile/power/user_login", qs.stringify(params));
  }
};
export default getUser;
